import React from 'react';
import PropTypes from 'prop-types';

function NoTestIcon({ width = 100, height = 100, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M83.3333 91.6664H16.6667C15.5616 91.6664 14.5018 91.2274 13.7204 90.446C12.939 89.6646 12.5 88.6048 12.5 87.4997V12.4997C12.5 11.3946 12.939 10.3348 13.7204 9.5534C14.5018 8.77199 15.5616 8.33301 16.6667 8.33301H83.3333C84.4384 8.33301 85.4982 8.77199 86.2796 9.5534C87.061 10.3348 87.5 11.3946 87.5 12.4997V87.4997C87.5 88.6048 87.061 89.6646 86.2796 90.446C85.4982 91.2274 84.4384 91.6664 83.3333 91.6664ZM79.1667 83.333V16.6663H20.8333V83.333H79.1667ZM33.3333 29.1663H66.6667V37.4997H33.3333V29.1663ZM33.3333 45.833H66.6667V54.1663H33.3333V45.833ZM33.3333 62.4997H66.6667V70.833H33.3333V62.4997Z"
        fill="#09121F"
      />
      <path
        d="M60 75C60 63.9543 68.9543 55 80 55C91.0457 55 100 63.9543 100 75C100 86.0457 91.0457 95 80 95C68.9543 95 60 86.0457 60 75Z"
        fill="#FAFBFF"
      />
      <path
        d="M80.0007 91.6663C70.7957 91.6663 63.334 84.2047 63.334 74.9997C63.334 65.7947 70.7957 58.333 80.0007 58.333C89.2057 58.333 96.6673 65.7947 96.6673 74.9997C96.6673 84.2047 89.2057 91.6663 80.0007 91.6663ZM80.0007 88.333C83.5369 88.333 86.9283 86.9283 89.4287 84.4278C91.9292 81.9273 93.334 78.5359 93.334 74.9997C93.334 71.4635 91.9292 68.0721 89.4287 65.5716C86.9283 63.0711 83.5369 61.6663 80.0007 61.6663C76.4644 61.6663 73.073 63.0711 70.5726 65.5716C68.0721 68.0721 66.6673 71.4635 66.6673 74.9997C66.6673 78.5359 68.0721 81.9273 70.5726 84.4278C73.073 86.9283 76.4644 88.333 80.0007 88.333ZM80.0007 72.643L84.714 67.928L87.0723 70.2863L82.3573 74.9997L87.0723 79.713L84.714 82.0713L80.0007 77.3563L75.2873 82.0713L72.929 79.713L77.644 74.9997L72.929 70.2863L75.2873 67.928L80.0007 72.643Z"
        fill="#FE0000"
      />
    </svg>
  );
}

NoTestIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};

export default NoTestIcon;
